import EmailResource from "../../resources/email-resource"

export const makeEmailResource = (): EmailResource => {
    return new EmailResource()
}
